var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isMarketWithoutSale
    ? _c("div", { class: _vm.bemBlock }, [
        _c(
          "div",
          { class: _vm.bemElement("content") },
          [
            _c("TheProductCustomizerMainSelector", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.mainProducts.length > 1,
                  expression: "mainProducts.length > 1"
                }
              ],
              attrs: { reset: _vm.reset }
            }),
            _vm._v(" "),
            _c("TheProductCustomizerComplementSelector", {
              attrs: { reset: _vm.reset }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cart-and-ipay",
                class: [
                  _vm.bemElement("add-to-cart"),
                  _vm.bemElement("actions")
                ]
              },
              [
                _c("input", {
                  staticClass: "add-to-cart-url",
                  attrs: { type: "hidden" },
                  domProps: { value: _vm.addToCartUrl }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    class: _vm.bemElement("total-price", "desktop"),
                    style: {
                      visibility: _vm.selectedMainProduct ? "visible" : "hidden"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$msg("price.total", "customizer") +
                            " " +
                            _vm.totalFormattedPrice
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: [
                      _vm.bemElement("add-to-cart-btn", ["desktop"]),
                      "btn",
                      "btn-primary",
                      "btn-big",
                      "interaction--add-to-bag"
                    ],
                    attrs: {
                      "data-interaction": "interaction--add-to-bag",
                      "data-interaction-state": _vm.initialStateAddToBag,
                      disabled: !_vm.selectedMainProduct
                    },
                    on: { click: _vm.handleAddToCart }
                  },
                  [
                    _c("BaseSpinner", { attrs: { small: "" } }),
                    _vm._v(" "),
                    _c("span", { staticClass: "default-content" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.selectedMainProduct
                              ? _vm.$msg("button.addtocart", "product")
                              : _vm.$msg("product.unavailable", "customizer")
                          ) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "swap-content" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$msg("product.added", "customizer")) +
                          "\n        "
                      )
                    ])
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            !_vm.productAddedToCart && _vm.isBreakpointMobile && _vm.ctaVisible
              ? _c(
                  "button",
                  {
                    class: [
                      _vm.bemElement("add-to-cart-btn", [
                        "mobile",
                        { "full-width": _vm.isAppRequest }
                      ]),
                      _vm.bemElement("actions"),
                      "add-to-cart-mobile",
                      "btn",
                      "btn--cta",
                      "interaction--add-to-bag-mobile"
                    ],
                    attrs: {
                      "data-interaction": "interaction--add-to-bag-mobile",
                      "data-interaction-state": _vm.initialStateAddToBagMobile,
                      disabled: !_vm.selectedMainProduct
                    },
                    on: { click: _vm.handleAddToCart }
                  },
                  [
                    _c("BaseSpinner", { attrs: { small: "", white: "" } }),
                    _vm._v(" "),
                    _c("span", { staticClass: "default-content" }, [
                      _vm.selectedMainProduct
                        ? _c(
                            "span",
                            { class: _vm.bemElement("total-price", "mobile") },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$msg("price.total", "customizer") +
                                      " " +
                                      _vm.totalFormattedPrice
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "one-size" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.selectedMainProduct
                                ? _vm.$msg("button.addtocart", "product")
                                : _vm.$msg("product.unavailable", "customizer")
                            ) +
                            "\n        "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "swap-content" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$msg("product.added", "customizer")) +
                          "\n      "
                      )
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.productAddedToCart && _vm.isBreakpointMobile
              ? _c(
                  "BaseModalCTA",
                  {
                    class: [
                      _vm.bemElement("actions"),
                      "the-product-details__actions"
                    ],
                    attrs: { "is-open": true, "no-padding": true }
                  },
                  [
                    _c("p", { class: [_vm.bemElement("text")] }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$msg("product.added", "customizer")) +
                          "\n      "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        class: [
                          _vm.bemElement("btn-modal", "btn-link"),
                          "btn",
                          "btn--cta"
                        ]
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$msg("price.total", "customizer") +
                                " " +
                                _vm.totalFormattedPrice
                            ) +
                            "\n      "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }